<template>
	<div>
		<v-layout class="mx-2 my-2">
			<MessageAuthor :message="message" :show-nova="showNova" />

			<!-- Message Text -->
			<div class="ml-3 mt-2" style="word-break: break-word; overflow-wrap: break-word; white-space: normal">
				<Flag v-if="!showNova" :lang="message.language" />
				{{ " " + message.text.trim() }}
			</div>
		</v-layout>

		<!-- MessageTranslations -->
		<div v-for="translation in translations">
			<v-divider />
			<v-layout class="mx-2 my-2">
				<div class="mx-3 my-2">
					<Flag :lang="translation.lang" />
					<span>{{ " " + message.translations[translation.lang].trim() }}</span>
				</div>
			</v-layout>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { AlternisMessage, Language } from "../../../../store/alternis_new";
import { useAlternisNewStore } from "../../../../store/alternis_new";
import { computed } from "vue";
import Flag from "./Flag.vue";
import MessageAuthor from "./MessageAuthor.vue";

const alternisStore = useAlternisNewStore();

const props = defineProps<{
	message: AlternisMessage;
}>();

const showNova = computed(
	() => props.message.sender === 0 && props.message["message-type"] === "text" && alternisStore.isVoicebot,
);

const otherParticipantLanguages = computed(() => {
	const lastBySender = new Map<number, AlternisMessage>();
	for (const msg of alternisStore.messages) {
		if (msg.language) lastBySender.set(msg.sender, msg);
	}
	const langs = new Set<Language>();
	for (const [sender, msg] of lastBySender) {
		if (sender !== props.message.sender && msg.language) langs.add(msg.language);
	}
	return langs;
});

const translations = computed(() =>
	Object.keys(props.message.translations)
		.filter((t) => t !== props.message.language && otherParticipantLanguages.value.has(t as Language))
		.map((lang) => translation(lang as Language)),
);

function translation(lang: Language): { lang: Language; value: string; audioId?: string } {
	if (!props.message.translations) return { lang, value: "No translation available" };
	if (lang in props.message.translations) return { lang, value: props.message.translations[lang] };
	return { lang, value: "" };
}
</script>
